module.exports = __webpack_public_path__ + "img/gntb_ynwx.0b7d2b33.png";